/**
 * Azure Application Insights Integration - Logging Only
 */
import { ApplicationInsights } from "@microsoft/applicationinsights-web"

let appInsights = null

const currentPageViewId = ""

const enableCorsCorrelation =
  process.env.NEXT_PUBLIC_APPLICATIONINSIGHTS_ENABLE_CORS_CORRELATION === "true"

const enableAutoRouteTracking =
  process.env.NEXT_PUBLIC_APPLICATIONINSIGHTS_TRACKING === "enabled"

// Helper function to safely access window object
const getWindow = () => {
  if (typeof window === "undefined") {
    return null
  }
  return window
}

/**
 * Initialize Azure Application Insights
 * @param {string} connectionString - The Application Insights connection string
 * @return {ApplicationInsights} - The initialized AppInsights instance
 */
export function initAppInsights(connectionString) {
  if (appInsights) {
    return appInsights
  }

  if (!connectionString) {
    console.error("Application Insights: Connection string is required")
    return null
  }

  try {
    appInsights = new ApplicationInsights({
      config: {
        connectionString: connectionString,
        enableAutoRouteTracking,
        enableCorsCorrelation,
        enableRequestHeaderTracking: false,
        enableResponseHeaderTracking: false,
        disableFetchTracking: false,
        enableAjaxPerfTracking: false,
        maxBatchInterval: 15000,
        disableFlushOnBeforeUnload: false,
        enableDebug: false,
        autoTrackPageVisitTime: false,
      },
    })

    // Initialize the SDK
    appInsights.loadAppInsights()

    const window = getWindow()
    if (window) {
      window.addEventListener("beforeunload", () => {
        appInsights.flush()
      })
    }

    return appInsights
  } catch (error) {
    console.error("Application Insights: Initialization failed", error)
    return null
  }
}

/**
 * Get the Application Insights instance
 * @return {ApplicationInsights|null}
 */
export function getAppInsights() {
  return appInsights
}

/**
 * Get current page view ID for correlation
 * @return {string}
 */
export function getCurrentPageViewId() {
  return currentPageViewId
}
